import React from "react";
import "./Features.css";

function Features({ features }) {
  return (
    <div className="container my-4">
      <div className="row">
        <div className="text-left col-12 fw-bold">
          {features.province} / {features.district} / {features.neighborhood}{" "}
          <i className="fa-solid fa-location-dot pb-1"></i>
        </div>
        <div className="col-12">
          <table className="table border-0 mb-0">
            <tbody>
              {features.left.map((feature, index) => (
                <tr
                  className={index % 2 === 0 ? "color-tr" : "color-tr2"}
                  key={index}
                >
                  <th>{feature.label}</th>
                  <td className="text-left">{feature.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="col-12">
          <table className="table border-0 mb-0">
            <tbody>
              {features.right.map((feature, index) => (
                <tr key={index}>
                  <th>{feature.label}</th>
                  <td className="text-left">{feature.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Features;
